module.exports = __webpack_public_path__ + "4d0c429f7d6639f606cb6425cb790ef2.png";